import { useNotificationStore } from "@/stores/NotificationStore";
import { useTvRatingStore } from "@/stores/TvRatingStore";
import { useMetaAudienceStore } from "@/stores/MetaAudienceStore";

export const NotificationStores = [
  useNotificationStore,
  useTvRatingStore,
  useMetaAudienceStore,
];

export const NotificationChannel = {
  received(payload) {
    this.notificationStore.handleReceivedNotification(payload);
    if (
      payload.meta_data?.creation_method === "audience-builder-3" &&
      payload.meta_data?.audience_name &&
      this.metaAudienceStore.metaAudiencesSummary?.data?.length
    ) {
      const audience = this.metaAudienceStore.metaAudiencesSummary.data.find(
        (audience) => audience.name === payload.meta_data.audience_name,
      );
      if (audience) {
        audience.status = "created";
      }
    }
    if (payload.subject === "Project Creation Complete") {
      this.tvRatingStore.getProjects();
    }
  },
};
